import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import saveAs from 'file-saver';
import { catchError, Observable, of, switchMap } from 'rxjs';

const RELEASE_PATH = '/customer/release';

@Injectable({
  providedIn: 'root',
})
export class ArtifactApiService {
  private httpClient = inject(HttpClient);

  downloadFileById(
    id: number,
    releaseId: number,
    fileName: string
  ): Observable<boolean> {
    return this.httpClient
      .get(
        `${environment.api_url}${RELEASE_PATH}/${releaseId}/artifact/${id}/download`,
        {
          observe: 'response',
          responseType: 'blob',
        }
      )
      .pipe(
        switchMap((response: HttpResponse<Blob>) => {
          if (response.body === null) {
            console.error('Received null response body');
            return of(false);
          }

          const contentType =
            response.headers.get('Content-Type') || 'application/octet-stream';
          const blob = new Blob([response.body], { type: contentType });

          saveAs(blob, fileName);
          return of(true);
        }),
        catchError((error) => {
          console.error('Ошибка загрузки:', error);
          return of();
        })
      );
  }
}
